import { Tree } from "@phosphor-icons/react";

export default function TreePostsTab({ posts }) {
  return (
    <div className="space-y-4" data-testid="admin-posts-tab">
      <div>
        <h2 className="font-heading text-xl font-semibold mb-1">Community Tree Posts</h2>
        <p className="text-xs text-stone-500 font-body">
          All tree planting posts submitted by community members. Each post includes GPS coordinates,
          photo verification, and estimated CO2 contribution (22kg per tree per year).
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {posts.map((p) => (
          <div key={p.id} className="bg-stone-900 rounded-xl border border-stone-800 p-4 flex items-start gap-4"
               data-testid={`admin-post-${p.id}`}>
            <div className="w-10 h-10 rounded-lg bg-emerald-600/20 flex items-center justify-center shrink-0">
              <Tree size={18} className="text-emerald-400" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-heading font-medium">{p.user_name}</p>
              <p className="text-xs text-stone-500 mt-0.5">{p.caption || "No caption"}</p>
              <div className="flex gap-4 mt-2 text-[10px] text-stone-400">
                <span className="text-emerald-400 font-medium">{p.trees_count} trees</span>
                <span>{p.co2_kg}kg CO2/yr</span>
                <span>{p.lat?.toFixed(3)}, {p.lon?.toFixed(3)}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
